import * as React from 'react';

interface LikeIconProps {
  width: number;
  height: number;
  fill?: string;
}

const LikeIcon = (props: LikeIconProps): JSX.Element => {
  const { width, height, fill } = props;

  return (
    <svg
      role="img"
      aria-label="좋아요 비활성화"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.824 4.005a5.068 5.068 0 0 0-3.753 1.937L12 6.036l-.07-.094A5.066 5.066 0 0 0 7.94 4C5.097 4 2.8 6.386 2.8 9.32a5.42 5.42 0 0 0 1.09 3.275l.124.158.382.449c1.175 1.338 3.37 3.338 6.587 6.004.663.55 1.626.54 2.279-.022l1.002-.869c3.007-2.626 4.895-4.449 5.691-5.505l.154-.215c.16-.208.312-.444.447-.695l.128-.256a.802.802 0 0 0 .059-.133c.294-.65.457-1.41.457-2.192C21.2 6.386 18.903 4 16.06 4l-.236.005zM16.06 5c2.282 0 4.14 1.93 4.14 4.32 0 .549-.098 1.082-.286 1.58l-.119.287-.006.013a4.521 4.521 0 0 1-.355.623l-.136.188c-.68 1.004-2.804 3.055-6.35 6.123l-.34.293a.765.765 0 0 1-.987.009l-1.058-.884c-2.714-2.287-4.564-4.01-5.541-5.155l-.118-.14A4.42 4.42 0 0 1 3.8 9.32C3.8 6.93 5.658 5 7.94 5c1.526 0 2.897.845 3.619 2.196l.441.826.441-.826C13.163 5.845 14.534 5 16.06 5z"
        fill={fill}
        fillRule="evenodd"
      />
    </svg>
  );
};

export default LikeIcon;
